class Overlay {
  constructor() {
    this.classes = {
      active: 'overlay--active',
    };

    this.element = document.createElement('div');
    this.element.classList.add('overlay');

    document.body.appendChild(this.element);

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
  }

  toggle() {
    if (this.element.classList.contains(this.classes.active)) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.element.classList.add(this.classes.active);
  }

  hide() {
    this.element.classList.remove(this.classes.active);
  }
}

const overlay = new Overlay();

export const { show, hide } = overlay;
